import type {AuthProvider} from "@refinedev/core";

const generateCodeVerifier = (length = 128) => {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
        .replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

const generateCodeChallenge = async (codeVerifier: string) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    const base64Digest = btoa(String.fromCharCode(...new Uint8Array(digest)));
    return base64Digest.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

export const authProvider: AuthProvider = {
    login: async (params: any) => {
        console.log('login', params)
        return {success: true};
    },
    check: async (params: any) => {
        // console.log('check', params)
        if (localStorage.getItem('user')) {
            return {authenticated: true}
        }
        try {
            const query = new URLSearchParams(window.location.search);
            const code = query.get("code");
            // console.log(code)
            if (code) {
                const codeVerifier = localStorage.getItem("pkce_code_verifier");
                const tokenResponse = await fetch(`${window.userprofile.url}/${window.userprofile.path.token}`, {
                    method: "POST", headers: {"Content-Type": "application/x-www-form-urlencoded"},
                    body: 'client_id=laadmin&grant_type=authorization_code&redirect_uri=' + encodeURI(window.location.origin)
                        + '&code=' + code + '&code_verifier=' + codeVerifier
                });
                const token = await tokenResponse.json();
                if (token && token.access_token) {
                    localStorage.setItem('token', token.access_token);
                    const response = await fetch(`${window.userprofile.url}/${window.userprofile.path.authenticate}`, {
                        headers: {Authorization: `Bearer ${token.access_token}`}
                    })
                    localStorage.setItem('user', JSON.stringify(await response.json()))
                    return {authenticated: true}
                }
                return {
                    authenticated: false,
                    error: {message: "Check failed", name: "Token not found"},
                    logout: true,
                };
            } else {
                const codeVerifier = generateCodeVerifier();
                const codeChallenge = await generateCodeChallenge(codeVerifier);
                localStorage.setItem("pkce_code_verifier", codeVerifier);
                const params = new URLSearchParams({
                    response_type: "code",
                    client_id: "laadmin",
                    auths: "file-laadmin",
                    redirect_uri: location.origin,
                    state: (Math.floor(Math.random() * Math.pow(2, 32))).toString(),
                    code_challenge: codeChallenge,
                    code_challenge_method: "S256"
                })
                window.location.href = `${window.userprofile.url}/${window.userprofile.path.authorize}?${params.toString()}`;
                return {
                    authenticated: false,
                    error: {message: "Check failed", name: "Token not found"},
                    logout: true,
                };
            }
        } catch (error: any) {
            return {
                authenticated: false,
                error: new Error(error),
                logout: true,
            };
        }
    },
    logout: async (params: any) => {
        console.log('logout', params)
        localStorage.removeItem('token');
        localStorage.removeItem('user')
        window.location.href = `${window.userprofile.url}/${window.userprofile.path.logout}?client_id=laadmin`
        // logout({returnTo: window.location.origin});
        return {success: true};
    },
    onError: async (error: any) => {
        console.log('error', error)
        if (error.response?.status === 401) {
            return {
                logout: true,
            };
        }
        return {error};
    },
    getPermissions: async (params: any) => console.log('getPermission', params),
    getIdentity: async (params: any) => {
        // console.log('getIdentity', params)
        const user = localStorage.getItem('user')
        if (!user) {
            return {
                authenticated: false,
                error: {message: "Identity failed", name: "Token not found"},
                logout: true,
            }
        }
        return JSON.parse(user)
    }
};